module.exports = " <div class=open_session _v-99116266=\"\"> <button @click=sessionStart class=sendMessage _v-99116266=\"\">发消息</button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-99116266!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/info/OpenSession.vue
 ** module id = 362
 ** module chunks = 2
 **/